import Group from 'components/utils/Group'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

export const AccommodationIndividualSelectRoomOptionTilePricingContainer = styled(Group)`
  position: relative;
`

function AccommodationIndividualSelectRoomOptionTilePricing(props: PropsWithChildren) {
  return <AccommodationIndividualSelectRoomOptionTilePricingContainer
    {...props}
    direction="vertical"
    verticalAlign="end"
    gap={12}
  />
}

export default AccommodationIndividualSelectRoomOptionTilePricing
